/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMoneyPoolPublicPreviewRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {GetMoneyPoolPublicPreviewResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const getMoneyPoolPublicPreview = (request: GetMoneyPoolPublicPreviewRequest, options?: CashRequestOptions) => post<GetMoneyPoolPublicPreviewRequest, GetMoneyPoolPublicPreviewResponse>("/cash-app/fiatly/get-pool-public-preview", request, {...options, rejectOnError: true })